import { type ReactNode } from 'react';
import { Button } from '@/components/ui/button';

export function ApproacherEditActions({
  onCancel,
  onSave,
  disabled,
}: {
  onCancel: () => void;
  onSave: () => void;
  disabled: boolean;
}): ReactNode {
  return (
    <div className="flex justify-end gap-sm">
      <Button variant="ghost" size="sm" onClick={onCancel}>
        Cancelar
      </Button>
      <Button size="sm" onClick={onSave} disabled={disabled}>
        Guardar
      </Button>
    </div>
  );
}
